export type SelectedOrder = {
  sourceIds: number[];
  orderNumber: string;
  recipientName: string;
};

export const getActivePlans = (order: SalesOrder) => order.fulfillmentPlans.filter((p) => p.orderGridStatus !== 'Cancelled');

export type FulfillmentPlan = {
  fulfillmentPlanId: string;
  shipmentNumber: string;
  orderGridStatus: string;
  itemCount: number;
  items?: Array<{
    name?: string;
    sku?: string;
    quantity?: number;
  }>;
};

export type SalesOrder = {
  salesOrderId: string;
  orderNumber: string;
  recipientName: string;
  orderDate: string;
  orderStatus: string;
  itemCount: number;
  fulfillmentPlans: FulfillmentPlan[];
};
